import { Select } from 'antd';
import React from 'react';
import { Controller, useController, UseControllerProps } from 'react-hook-form';
import { handleError } from 'utils/component.util';

type RadioType = UseControllerProps & {
  options: { value: string | number; label: string }[];
  className?: string;
  placeholder?: string;
  mode?: 'multiple' | 'tags';
  disabled?: boolean;
};
const FormSelect: React.FC<RadioType> = (props) => {
  const { control, placeholder, options, name, disabled } = props;
  const {
    fieldState: { error },
  } = useController(props);

  return (
    <div className={`relative ${props.className} min-h-[50px]`}>
      <div className="absolute w-full">
        <Controller
          control={control}
          name={name}
          render={({ field: { onChange, value } }): JSX.Element => (
            <Select
              mode={props.mode}
              disabled={disabled}
              options={options}
              getPopupContainer={(trigger): HTMLElement => trigger.parentNode} // need for scrolling sticky header
              className="w-full"
              placeholder={placeholder}
              onChange={onChange}
              value={value}
            />
          )}
        />
        <div>{handleError(error, props.rules)}</div>
      </div>
    </div>
  );
};

export default FormSelect;
